export const safeToWork = 'SafeToWork';
export const stayHome = 'StayHome';
export const getCare = 'GetCare';
export const fahrenheit = 'Fahrenheit';
export const celsius = 'Celsius';
